import { z } from "zod";
import { Links, NeoBrowse, NeoFeed, ObjectInfo } from "./types";
import { Temporal } from "temporal-polyfill";
const API_KEY = "hZlodbwFTmFSYbIXQvto2axDP6PcPIdKThKLVJMP";
const BASE_URL = "https://api.nasa.gov/neo/rest/v1/";

export class NoPreviousOrNext extends Error {
  constructor(message: string) {
    super(message);
    this.name = "NoPreviousOrNext";
  }
}

// TODO save previous links
async function fetch_link(url: URL | string): Promise<object> {
  if (typeof url == "string") {
    url = new URL(url);
  }
  url.searchParams.append("api_key", API_KEY);
  const data = await fetch(url);

  return await data.json();
}

export async function feed(from: Temporal.PlainDate, to: Temporal.PlainDate): Promise<z.infer<typeof NeoFeed>> {
  // TODO check the date range
  if (Temporal.PlainDate.compare(from.add({ days: 7 }), to) == -1) {
    throw new RangeError("Range between from and to dates is larger than 7 days.");
  }
  const url = new URL(BASE_URL);
  url.pathname += "feed";
  url.searchParams.append("start_date", from.toString());
  url.searchParams.append("end_date", to.toString());

  return NeoFeed.parse(await fetch_link(url));
}

export async function lookup_object(asteroid_id: number): Promise<z.infer<typeof ObjectInfo>> {
  const url = new URL(BASE_URL);
  url.pathname += `neo/${asteroid_id.toString()}`;

  return ObjectInfo.parse(await fetch_link(url));
}

export async function next_page<T extends typeof Links>(data: z.infer<T>, parser: T): Promise<z.infer<T>> {
  if (data.links.next === undefined) {
    throw new NoPreviousOrNext("There is no next page");
  }
  return parser.parse(await fetch_link(data.links.next));
}

export async function previous_page<T extends typeof Links>(data: z.infer<T>, parser: T): Promise<z.infer<T>> {
  if (data.links.previous === undefined) {
    throw new NoPreviousOrNext("There is no previous page");
  }
  return parser.parse(await fetch_link(data.links.previous));
}

export async function browse(): Promise<z.infer<typeof NeoBrowse>> {
  const url = new URL(BASE_URL);
  url.pathname += "neo/browse";

  return NeoBrowse.parse(await fetch_link(url));
}
